<template>
    <div class="center">
        <div class="upload-header">
            {{ $vuetify.lang.t('$vuetify.employeeImportList.uploadFile') }}
        </div>
        <div class="upload-subheader mt-2">
            {{ $vuetify.lang.t('$vuetify.employeeImportList.shouldBeExcel') }}
        </div>
        <div
         @dragover="dragOver"
         @dragleave="dragLeave"
         @dragstart.prevent="drag"
         @dragover.prevent
         @drop.prevent
         @drop="drop"
         class="upload-file-card">

        <div
         class="disabled-drag-area">
            <div class="d-flex-center">
                <img
                    :class="classDragged"
                    src="@/assets/employee/import-excel.png">
            </div>
            <div>
                <span class="drag-drop-text">
                    {{ $vuetify.lang.t('$vuetify.employeeImportList.dragDrop') }}
                </span>
                <span
                    :class="onDrag"
                    @click="selectFile()"
                    class="browse-text">
                    {{ $vuetify.lang.t('$vuetify.employeeImportList.browse') }}
                </span>
                <input
                    ref="browseFile"
                    type="file"
                    class="browse-file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    @change="onSelectFile">
            </div>
        </div>
    </div>

    <import-employee-result-modal
            ref="importEmployeeResultModal"
            :title="importResult.title"
            :contentList="importResult.contentList" />

    <import-employee-error-modal
        ref="importEmployeeErrorModal"
        :error="importError"
        @download-error-file="downloadImportErrorFile()" />
    </div>

</template>

<script>
import EmployeeImportMixin from '@/mixins/components/EmployeeImportMixin'

export default {
    name: 'EmployeeImportFile',

    mixins: [EmployeeImportMixin],

    methods: {
        showUploadResult (data) {
            this.importResult = {
                title: this.$vuetify.lang.t('$vuetify.employeeImportImage.importResult'),
                contentList: data
            }

            this.$refs.importEmployeeResultModal.showModal()
        },

        async drop (event) {
            this.isDrag = false
            const droppedFiles = event.dataTransfer.files
            const spreadSheetType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            const excelType = 'application/vnd.ms-excel'

            // check amount of uploading file and cannot upload while uploading
            if (droppedFiles.length > 1 && this.isUploading === true) {
                this.$store.dispatch('setErrorModalShow', true)
                this.$store.dispatch('setErrorModalMsg', this.$vuetify.lang.t('$vuetify.employeeImportList.uploadOneFile'))
            }

            // check file type
            if (droppedFiles[0] && (droppedFiles[0].type === spreadSheetType || droppedFiles[0].type === excelType)) {
                this.file = droppedFiles[0]
                await this.uploadFile()
            } else {
                this.$store.dispatch('setErrorModalShow', true)
                this.$store.dispatch('setErrorModalMsg', this.$vuetify.lang.t('$vuetify.employeeImportList.wrongFileFormat'))
            }
        },

        async downloadImportErrorFile () {
            this.$store.dispatch('setLoading', true)

            const urlLink = 'employee-export/list-error'
            const formData = new FormData()
            formData.append('branch', this.branchId)
            formData.append('file', this.file)
            const config = {
                headers: {
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                },
                responseType: 'arraybuffer'
            }
            const response = await this.axios.post(urlLink, formData, config)

            if (response && response.data) {
                this.$util.downloadExcelFile(response.data, 'Error list.xlsx')
                this.$store.dispatch('setLoading', false)
            }
        },

        async uploadFile () {
            this.$store.dispatch('setLoading', true)

            this.isUploading = true
            const toUploadFile = {
                name: this.file.name,
                loadingPercent: 0,
                typeFile: 'excel',
                isSuccess: true
            }
            this.uploadFiles.unshift(toUploadFile)

            const formData = new FormData()
            formData.append('branch', this.branchId)
            formData.append('file', this.file)

            const url = 'attendances/import-monthly'
            const config = {
                headers: { 'Content-Type': 'application/form-data' },
                onUploadProgress: progressEvent => {
                    this.uploadFiles[0].loadingPercent = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
                }
            }
            const res = await this.axios.post(url, formData, config)

            if (res && res.data) {
                if (res.data.status === 'ok' && res.data.data) {
                    this.uploadFiles[0].isSuccess = true
                    this.showUploadResult(res.data.data)
                } else if (res.data.status === 'error') {
                    this.uploadFiles[0].isSuccess = false
                    this.$refs.importEmployeeErrorModal.showModal()
                    this.importError = {
                        description: res.data.data.description
                    }
                } else {
                    this.uploadFiles[0].isSuccess = false
                    this.$store.dispatch('setErrorModalShow', true)
                    this.$store.dispatch('setErrorModalMsg', res.data.msg)
                }
            }

            this.$refs.browseFile.value = null
            this.isUploading = false
            this.$forceUpdate()
            this.$store.dispatch('setLoading', false)
        }
    }

}
</script>

<style lang="scss" scoped>

.center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.upload-header, .condition {
    font-size: 18px;
    font-weight: bold;
}
.condition-desc {
    color: #6c6c6c;
}
.upload-subheader {
    color: #6c6c6c;
}
.upload-file-card {
    margin-top: 1.5rem;
    width: 500px;
    height: 250px;
    border-radius: 20px;
    border: dashed 2px #139888;
    background-color: #f7fcfb;
    display: flex;
    justify-content: center;
    align-items: center;
}
.drag-drop-text {
    color: #a8a8a8;
}
.browse-text {
    color: #d76436;
    text-decoration: underline;
    cursor: pointer;
    pointer-events: all;
}
.big-image {
    width: 120px;
}
.browse-file {
    display: none;
}
.disabled-drag-area {
    width: 100%;
    height: 100%;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.uploaded-file-header {
    margin-top: 1rem;
    font-size: 18px;
    font-weight: bold;
}
.on-drag {
    pointer-events: none;
}

</style>
